import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { LoadingComponent } from '../loading/loading.component';

type Variant = 'primary' | 'secondary' | 'tertiary';

@Component({
    selector: 'button[appButton]',
    imports: [LoadingComponent],
    template: `
    @if (loading()) {
      <app-loading [isLoading]="true"/>
    } @else {
      <ng-content />
    }
    `,
    hostDirectives: [
        { directive: MatRipple }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      '[class]': 'loading() ? "new-btn" : hostClass()',
      '[disabled]': 'disabled() || loading()',

      '[style.width.px]' : 'loading() ? loadingWidth() : null',
      '[style.height.px]' : 'loading() ? loadingHeight() : null',
    },
    styleUrl: '../../styles/components/buttons.scss', //
    standalone: true
})
/*

  Three kinds of buttons: primary, secondary, tertiary

  Usage example primary: <button appButton> clic me </button>
  Usage example secondary: <button appButton="secondary"> clic me </button>

*/

export class ButtonComponent {
  appButton = input<Variant>('primary');
  loading = input<boolean>(false);
  disabled = input<boolean>(false);

  // Optional height and width when loading,
  // ideally it would be automatic?
  loadingWidth = input<number>(120);
  loadingHeight = input<number>(46);

  private greyClass = computed(() => {
    return !this.loading() && this.disabled() ? "grey" : "";
  });

  private variantClass = computed(() => {
    switch (this.appButton()) {
      case 'secondary': return 'secondary-btn';
      case 'tertiary': return 'tertiary-btn';
      default: return 'primary-btn';
    }
  });

  hostClass = computed(() => `new-btn ${this.greyClass()} ${this.variantClass()}`);
}
